export const CLIENT_EVENT_TYPE = {
  VERSION_MISMATCH: "VERSION_MISMATCH",
  CHUNK_LOAD_ERROR: "CHUNK_LOAD_ERROR",
  AUTO_RELOAD_ATTEMPT: "AUTO_RELOAD_ATTEMPT",
  MANUAL_RELOAD_ATTEMPT: "MANUAL_RELOAD_ATTEMPT",
  RECOVERY_SUCCESS: "RECOVERY_SUCCESS",
  RECOVERY_FAILED: "RECOVERY_FAILED"
} as const;

export const RECOVERY_STATUS = {
  NOT_ATTEMPTED: "NOT_ATTEMPTED",
  ATTEMPTED: "ATTEMPTED",
  SUCCESS: "SUCCESS",
  FAILED: "FAILED"
} as const;

export type ClientEventType =
  typeof CLIENT_EVENT_TYPE[keyof typeof CLIENT_EVENT_TYPE];
export type RecoveryStatus =
  typeof RECOVERY_STATUS[keyof typeof RECOVERY_STATUS];

export interface ClientLogPayload {
  storeNumber: string;
  timestamp: string;
  eventType: ClientEventType;
  buildVersion: string;
  expectedVersion?: string;
  sessionId: string;
  browserType: string;
  recoveryStatus: RecoveryStatus;
}
